export default "__VITE_ASSET__BThEApMP__"